import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { external: Boolean };
  static targets = ['fullTab', 'linkTab', 'fullPanel', 'linkPanel', 'hiddenField'];

  connect() {
    this._update();
  }

  showFull() {
    this.externalValue = false;
    this._update();
  }

  showLink() {
    this.externalValue = true;
    this._update();
  }

  _update() {
    var isExternal = this.externalValue;

    if (this.hasFullTabTarget) {
      this.fullTabTarget.classList.toggle('active', !isExternal);
    }
    if (this.hasLinkTabTarget) {
      this.linkTabTarget.classList.toggle('active', isExternal);
    }
    if (this.hasFullPanelTarget) {
      this.fullPanelTarget.style.display = isExternal ? 'none' : '';
    }
    if (this.hasLinkPanelTarget) {
      this.linkPanelTarget.style.display = isExternal ? '' : 'none';
    }
    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.value = isExternal ? '1' : '0';
    }
  }
}
